<template>
  <div class="rounded-xl border border-steel-40 bg-white">
    <div
      class="flex items-center justify-between border-b border-steel-40 px-4 py-2"
    >
      <div class="flex items-center gap-1">
        <img
          class=""
          :src="equipment.verified ? verifiedIcon : unverifiedIcon"
          :alt="equipment.verified ? 'Verified Icon' : 'Unverified Icon'"
        />
        <span class="text-steel-1100">
          {{ equipment.verified ? 'Verified' : 'Unverified' }}
        </span>
      </div>
      <p class="font-medium text-steel-1100">
        <span class="text-sm text-steel-700">VIN</span> {{ equipment.vin }}
      </p>
    </div>
    <div class="flex flex-col gap-1 px-4 py-2">
      <div class="grid grid-cols-4 text-left">
        <span class="col-span-1 text-sm font-normal text-steel-700"
          >Truck #</span
        >
        <span class="col-span-3 truncate text-sm font-medium text-steel-900">{{
          equipment.truck_number
        }}</span>
      </div>
      <div class="grid grid-cols-4 text-left">
        <span class="col-span-1 text-sm font-normal text-steel-700"
          >Vehicle</span
        >
        <span class="col-span-3 truncate text-sm font-medium text-steel-900">{{
          [equipment?.year, equipment?.model, equipment?.make]
            .filter(Boolean)
            .join(' ')
        }}</span>
      </div>
      <div class="grid grid-cols-4 text-left">
        <span class="col-span-1 text-sm font-normal text-steel-700"
          >Source</span
        >
        <span class="col-span-3 truncate text-sm font-medium text-steel-900">{{
          equipment.source
        }}</span>
      </div>
      <div class="grid grid-cols-4 text-left">
        <span class="col-span-1 text-sm font-normal text-steel-700"
          >Last Seen</span
        >
        <span class="col-span-3 truncate text-sm font-medium text-steel-900">{{
          formattedLastSeen
        }}</span>
      </div>
    </div>

    <div
      class="flex items-center justify-between rounded-b-xl bg-steel-100 px-4 py-2"
    >
      <div class="flex items-center">
        <span class="mr-2 text-sm text-steel-700">ELD</span>
        <img
          :src="
            equipment.is_eld_and_active ? eldConnectedIcon : eldNotConnectedIcon
          "
          :alt="
            equipment.is_eld_and_active
              ? 'ELD Connected Icon'
              : 'ELD Not Connected Icon'
          "
        />
        <p class="ml-1">
          {{ equipment.is_eld_and_active ? 'Connected' : 'Not Connected' }}
        </p>
      </div>
      <div class="flex items-center">
        <span class="mr-2 text-sm text-steel-700">COI</span>
        <img
          :src="equipment.is_coi ? insuredIcon : coiNotFoundIcon"
          :alt="equipment.is_coi ? 'Insured Icon' : 'COI Not Found Icon'"
        />
        <p class="ml-1">{{ equipment.is_coi ? 'Insured' : 'Not Found' }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import { computed } from 'vue';

import verifiedIcon from '@/assets/verified-icon.svg';
import unverifiedIcon from '@/assets/unverified-icon.svg';
import eldConnectedIcon from '@/assets/eld-connected-icon.svg';
import eldNotConnectedIcon from '@/assets/eld-not-connected-icon.svg';
import insuredIcon from '@/assets/insured-icon.svg';
import coiNotFoundIcon from '@/assets/coi-not-found-icon.svg';

const props = defineProps({
  equipment: {
    type: Object,
    default: () => ({}),
  },
});

const formattedLastSeen = computed(() =>
  dayjs(props.equipment.last_seen).format('MM/DD/YYYY')
);
</script>
